// extracted by mini-css-extract-plugin
export var backingPulse = "welcome-module--backing-pulse--aa108";
export var fadeoutBack = "welcome-module--fadeout-back--989c1";
export var logoPulse = "welcome-module--logo-pulse--5c349";
export var welcomeInner = "welcome-module--welcome-inner--1f42e";
export var welcomeWrapper = "welcome-module--welcome-wrapper--c3503";